import { EChartView } from "@/components/ui/echart-view"
import type { EChartsOption } from "echarts"

interface ChartWidgetProps {
  data?: any
  config?: Record<string, any>
}

export function ChartWidget({ data, config }: ChartWidgetProps) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
        No data available
      </div>
    )
  }

  // Simple chart configuration - can be enhanced based on config
  const chartType = config?.chartType || "bar"
  const xAxis = config?.xAxis || Object.keys(data[0])[0]
  const yAxis = config?.yAxis || Object.keys(data[0])[1]
  const category = config?.category || config?.xAxis || Object.keys(data[0])[0]
  const value = config?.value || config?.yAxis || Object.keys(data[0])[1]

  let option: EChartsOption | null = null

  if (chartType === "pie") {
    option = {
      tooltip: {
        trigger: "item",
      },
      series: [
        {
          type: "pie",
          radius: "75%",
          data: data.map((row: any) => ({
            name: String(row[category] || ""),
            value: Number(row[value]) || 0,
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    }
  } else if (chartType === "bar") {
    option = {
      xAxis: {
        type: "category",
        data: data.map((row: any) => String(row[xAxis] || "")),
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          type: "bar",
          data: data.map((row: any) => Number(row[yAxis]) || 0),
        },
      ],
    }
  } else if (chartType === "line") {
    option = {
      xAxis: {
        type: "category",
        data: data.map((row: any) => String(row[xAxis] || "")),
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          type: "line",
          data: data.map((row: any) => Number(row[yAxis]) || 0),
        },
      ],
    }
  }

  return <EChartView option={option} height={300} />
}
